module.exports = __webpack_public_path__ + "img/002.b969fcf3.jpg";